module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"CheckoutHeader":{"heading":"Potřebujete poradit?"}},"en":{"CheckoutHeader":{"heading":"Do you need help?"}}}')
  delete Component.options._Ctor
}
